"use client"

export default function Home() {
  return (
    <main className="min-h-screen bg-neutral-950 text-neutral-100">
      <div className="mx-auto max-w-xl px-6 py-16">
        <p className="font-mono text-xs uppercase tracking-widest text-neutral-500">
          Nexus · IA Work
        </p>
        <h1 className="mt-2 font-semibold text-2xl">Editor IA</h1>
        <p className="mt-3 text-sm text-neutral-400">
          Este é o editor 3D do IA Work. Os projetos ficam no Nexus — abra o
          editor pela tela <strong>IA Work</strong> (item do menu principal).
          Esta URL direta exige um identificador de projeto
          (<code className="font-mono">/p/&lt;id&gt;</code>).
        </p>
      </div>
    </main>
  )
}
